import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { BrowserMultiFormatReader } from '@zxing/browser';
import { API_BASE } from '../lib/config';

const API = `${API_BASE}`;

const getPosition = () => new Promise((resolve) => {
  try {
    if (!navigator.geolocation) return resolve({ coords: { latitude: null, longitude: null } });
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve(pos),
      () => resolve({ coords: { latitude: null, longitude: null } }),
      { enableHighAccuracy: true, timeout: 5000 }
    );
  } catch {
    resolve({ coords: { latitude: null, longitude: null } });
  }
});

const QRCheckIn = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const videoRef = useRef(null);
  const [error, setError] = useState('');
  const [scanning, setScanning] = useState(true);

  // Optional: allow prefilled token via query param
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const payload = params.get('p');
    if (payload) {
      handlePayload(payload);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    let reader;
    (async () => {
      try {
        reader = new BrowserMultiFormatReader();
        const constraints = { video: { facingMode: 'environment' } };
        const stream = await navigator.mediaDevices.getUserMedia(constraints);
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          await videoRef.current.play();
        }
        const controls = await reader.decodeFromVideoDevice(null, videoRef.current, (result, err) => {
          if (result && scanning) {
            setScanning(false);
            const text = result.getText();
            handlePayload(text);
            if (controls && controls.stop) controls.stop();
          }
        });
        return () => controls && controls.stop();
      } catch (e) {
        console.error(e);
        setError('カメラを起動できませんでした。許可を確認してください。');
      }
    })();
    return () => {
      try {
        const tracks = videoRef.current?.srcObject?.getTracks?.() || [];
        tracks.forEach((t) => t.stop());
      } catch {}
    };
    // eslint-disable-next-line
  }, [scanning]);

  const handlePayload = async (text) => {
    try {
      // payload format: job_id|token OR just token
      let jobId = '';
      let token = text;
      if (text.includes('|')) {
        const [j, t] = text.split('|');
        jobId = (j || '').trim();
        token = (t || '').trim();
      }
      if (!token) throw new Error('無効なQRです');
      const auth = localStorage.getItem('token');
      const pos = await getPosition();
      const body = {
        job_id: jobId || undefined,
        latitude: pos?.coords?.latitude,
        longitude: pos?.coords?.longitude,
        device_time: new Date().toISOString(),
        qr_token: token,
      };
      const resp = await fetch(`${API}/attendance/clock-in`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${auth}` },
        body: JSON.stringify(body),
      });
      if (!resp.ok) {
        throw new Error(`check-in failed: ${resp.status}`);
      }
      await resp.json();
      alert('チェックインしました');
      navigate('/work');
    } catch (e) {
      console.error(e);
      setError('チェックインに失敗しました');
      setScanning(true);
    }
  };

  return (
    <div className="min-h-screen bg-black text-white">
      <div className="max-w-md mx-auto p-4">
        <div className="flex items-center justify-between mb-4">
          <button onClick={() => navigate(-1)} className="text-gray-300">戻る</button>
          <h1 className="text-lg font-bold">QRスキャンでチェックイン</h1>
          <div />
        </div>
        <div className="rounded overflow-hidden border border-gray-700">
          <video ref={videoRef} className="w-full h-80 object-cover bg-black" muted playsInline></video>
        </div>
        {error && (
          <div className="mt-3 text-sm text-red-400">{error}</div>
        )}
        <div className="mt-4 flex gap-2">
          <button onClick={() => setScanning(true)} className="px-3 py-2 bg-blue-600 rounded">再スキャン</button>
          <button onClick={() => navigate('/work')} className="px-3 py-2 bg-gray-700 rounded">キャンセル</button>
        </div>
      </div>
    </div>
  );
};

export default QRCheckIn;
